import { render, staticRenderFns } from "./_no-access.vue?vue&type=template&id=7323a6c6&scoped=true"
import script from "./_no-access.vue?vue&type=script&lang=js"
export * from "./_no-access.vue?vue&type=script&lang=js"
import style0 from "./_no-access.vue?vue&type=style&index=0&id=7323a6c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7323a6c6",
  null
  
)

export default component.exports